import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "confirmation", "submit"]

  open() {
    this.dialogTarget.showModal()
    this.confirmationTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  validate() {
    this.submitTarget.disabled = this.confirmationTarget.value !== "delete"
  }
}
